import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';

const SvgIcon = createSvgIcon(
  [
    <circle key='0' fill='#4CAF50' cx='12' cy='12' r='12' />,
    <path
      key='1'
      fill='#FFFFFF'
      d='M18.2,8L18.2,8l-2.6-2.6l-0.7,0.7l1.4,1.4c-0.6,0.3-1.1,0.9-1.1,1.6c0,1,0.8,1.7,1.7,1.7c0.3,0,0.5-0.1,0.7-0.2
	v5c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7v-3.2c0-0.7-0.6-1.4-1.4-1.4h-0.7V6.5c0-0.7-0.6-1.4-1.4-1.4H8.6
	c-0.7,0-1.4,0.6-1.4,1.4v11.1h7v-5.3h1.1v3.4c0,1,0.8,1.7,1.7,1.7c0.9,0,1.7-0.8,1.7-1.7V9.3C18.8,8.7,18.5,8.4,18.2,8z M12.8,9.9
	H8.6V6.5h4.2V9.9z M16.9,9.9c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7S17.4,9.9,16.9,9.9z'
    />,
  ],
  'TransportConditionGeofenceFull'
);

const TransportConditionGeofenceDrainIcon = function (props) {
  return <SvgIcon {...props} />;
};

export default memo(TransportConditionGeofenceDrainIcon);
